// Bracket types for the Global Bracket feature (Phase 09)
// One bracket per user, 15 series across 4 rounds.
// R1 + Finals picks include predicted_score + odds_at_bet.
// R2/CF picks have winner only.

export type BracketRound =
  | 'round1'
  | 'first_round'
  | 'west_semis'
  | 'east_semis'
  | 'west_finals'
  | 'east_finals'
  | 'finals';

export interface BracketPick {
  winner: string;                 // team name
  predicted_score: string | null; // e.g. "4-2" — only for R1 and Finals
  odds_at_bet: number | null;     // American odds at save time — only for R1 and Finals
}

// The full picks object: keyed by series ID
export type BracketPicks = Record<string, BracketPick>;

export interface BracketEntry {
  id: string;
  user_id: string;
  display_name: string;
  picks: BracketPicks;
  odds_snapshot: Record<string, unknown>;
  locked_at: string | null;
  total_points: number;
  created_at: string;
  updated_at: string;
}

export interface GlobalLeaderboardEntry {
  id: string;
  user_id: string;
  display_name: string;
  total_points: number;
  correct_winners: number;
  correct_scores: number;
  rank: number;
  updated_at: string;
  avatar_id?: number | null;
}

// NBA bracket structure: 15 series across 4 rounds
// R1: 8 series (4 West + 4 East), R2: 4 series (2 West + 2 East)
// CF: 2 series (West Finals + East Finals), Finals: 1 series
export const BRACKET_OPEN_DATE = '2026-04-13T05:00:00Z';
export const BRACKET_DEADLINE = '2026-04-18T17:00:00Z';

// All rounds require score predictions in the Global Bracket (flat 200/400 scoring)
export const ROUNDS_WITH_SCORE: BracketRound[] = [
  'round1', 'first_round',
  'west_semis', 'east_semis',
  'west_finals', 'east_finals',
  'finals',
];
